<template>
        <form>

            <div class="input-group" :class="{ error : containsError('email')}">
                <label for="email">E-mail</label>
                <input type="email" name="email" id="email" v-model="email" @keyup.enter.prevent="submit"  />
            </div>

            <div class="input-group" :class="{ error : containsError('password')}">
                <label for="password">Wachtwoord bevestiging</label>
                <input type="password" name="password" id="password" v-model="password" @keyup.enter.prevent="submit" />
            </div>

            <primary-button @clicked="submit" :loading="loading" >Opslaan</primary-button>

        </form>
</template>


<script>
import api from 'js/api/resources';
import notify from 'js/components/notifications/notificationsMixin';
import validation from 'js/components/auth/validationMixin';
import { transform } from 'js/vuex/helpers';

import PrimaryButton from 'js/components/elements/PrimaryButton.vue';

export default {
    name: 'SettingsUser',
    mixins: [ notify, validation ],
    components: { PrimaryButton },
    props: {
        user: {},
    },
    data: function() {
        return {
            password: null,
            new_email: null,
            loading: false,
            errors: [],
            errorFields: [],
        }
    },
    vuex: {
        getters: {
            isDemo: state => state.users.current.role === 'demo'
        },
        actions: {
            storeUser: ({dispatch}, user) => dispatch('SET_CURRENT_USER', user)
        }
    },
    computed: {

        email: {
            get: function() {
                return this.new_email == null ? this.user.email : this.new_email
            },
            set: function(value) {
                this.new_email = value
            }
        }

    },
    methods: {
        submit: function(e) {

            e.preventDefault();

            if ( this.validate() ) {

                if ( this.isDemo ) {
                    this.$demoSuccessNotification()
                    this.reset()
                    return
                }

                if ( this.email.trim() === this.user.email ) {
                    this.$success('E-mailadres blijft ' + this.email, { id: 'validation'  } )
                    this.reset()
                    return
                }

                this.loading = true

                api.editUserEmail(this.user.id, this.email, this.password)
                    .then( response => transform(response.body) )
                    .then( result => this.storeUser(result.users[0]) )
                    .then( () => {
                        this.$success('Je e-mailadres is aangepast. Er is een mail verstuurd naar ' + this.email + ' met instructies om je nieuwe adres te bevestigen.', { id: 'validation'  } )
                    })
                    .catch( response => {
                        if ( response.status === 403 ) {
                            this.addError('password', 'Je huidige wachtwoord klopt niet.')
                            this.showErrors()
                        } else {
                            this.handleErrorResponse(response, 'Gegevens aanpassen is mislukt.')
                        }
                    })
                    .then( () => {
                        this.loading = false
                        this.reset()
                    })

            }

        },
        reset: function() {
            this.password = ''
        },
        validateFields: function() {
            this.validatePasswordLength(this.password)
            this.validateEmail(this.email)
        },

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Email.vue?f52056ce